export default __webpack_public_path__ + "static/media/08_Lori_berd.a80ecc58.jpg";